import { action, computed, makeObservable, observable, override } from 'mobx';

import type { ModularLayoutBasicData } from '../../../data/model';
import { ExternalConfiguratorModalTranslation } from '../../../localization/SiteTranslation';
import { ModalState } from '../../../shared/ModalState';
import PconUrlBuilder from '../../../shared/pCon/PconUrlBuilder';

export default class ExternalConfiguratorModalState extends ModalState {
  @observable
  public isLoading = true;

  @observable.ref
  public selectedLayout?: ModularLayoutBasicData;

  public readonly confirmationModal = new ModalState();

  public constructor(
    private readonly languageCode: string,
    private readonly externalConfiguratorLink: string,
    public readonly translation: ExternalConfiguratorModalTranslation,
  ) {
    super();

    makeObservable(this);
  }

  @computed
  public get configuratorUrl(): string {
    return PconUrlBuilder.build(
      this.selectedLayout?.externalConfiguratorLink || this.externalConfiguratorLink,
      this.languageCode,
    );
  }

  public canConfigure(): boolean {
    return !!this.externalConfiguratorLink;
  }

  public canConfigureLayout(layout: ModularLayoutBasicData): boolean {
    return !!layout?.externalConfiguratorLink;
  }

  @override
  public open(layout?: ModularLayoutBasicData): Promise<void> {
    this.selectedLayout = layout;

    return super.open();
  }

  @action.bound
  public setLoaded() {
    this.isLoading = false;
  }

  protected onBeforeOpen() {
    this.isLoading = true;
  }

  protected onAfterClose() {
    this.confirmationModal.close();
    super.onAfterClose();
  }
}
